<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import WithLabel from 'v3/components/Form/WithLabel.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const salesAssistStatus = ref('active');
const isSubmitting = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { sales_assist_enabled } = currentAccount.value?.settings || {};
    salesAssistStatus.value = sales_assist_enabled || 'active';
  },
  { deep: true, immediate: true }
);

const handleSubmit = async () => {
  try {
    isSubmitting.value = true;
    await updateAccount(
      { sales_assist_enabled: salesAssistStatus.value },
      { silent: true }
    );
    useAlert(t('GENERAL_SETTINGS.FORM.SALES_ASSIST.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.SALES_ASSIST.API.ERROR'));
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.SALES_ASSIST.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.SALES_ASSIST.NOTE')"
    with-border
  >
    <form class="grid gap-4" @submit.prevent="handleSubmit">
      <WithLabel :label="t('GENERAL_SETTINGS.FORM.SALES_ASSIST.LABEL')">
        <select v-model="salesAssistStatus" class="!mb-0 text-sm">
          <option value="active">
            {{ t('GENERAL_SETTINGS.FORM.SALES_ASSIST.ACTIVE') }}
          </option>
          <option value="inactive">
            {{ t('GENERAL_SETTINGS.FORM.SALES_ASSIST.INACTIVE') }}
          </option>
        </select>
      </WithLabel>
      <div>
        <NextButton
          blue
          type="submit"
          :is-loading="isSubmitting"
          :label="t('GENERAL_SETTINGS.FORM.SALES_ASSIST.UPDATE_BUTTON')"
        />
      </div>
    </form>
  </SectionLayout>
</template>
